import { render, staticRenderFns } from "./sms.vue?vue&type=template&id=5cf0974f&scoped=true&"
import script from "./sms.vue?vue&type=script&lang=js&"
export * from "./sms.vue?vue&type=script&lang=js&"
import style0 from "./sms.vue?vue&type=style&index=0&id=5cf0974f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0974f",
  null
  
)

component.options.__file = "sms.vue"
export default component.exports